module.exports = __webpack_public_path__ + "img/mira_790d_list.87617847.jpg";